module.exports = __webpack_public_path__ + "static/media/0.b9f0fb48.jpg";